import axios from 'axios';

const auth = (token) => ({ Authorization: token });

export const login = async (email, password) => axios.post(`${ process.env.REACT_APP_API_URL }user/login`, {
  email,
  password
});

export const getUser = async (token) => axios.get(`${ process.env.REACT_APP_API_URL }user`, { headers: auth(token) });

export const logout = async (token) => axios.post(`${ process.env.REACT_APP_API_URL }user/logout`, {}, { headers: auth(token) });

export const loadBooks = async (page, {bookId, title, author, isbn, showNoMainBook, showOnlyWantToRead, showOnlyAlreadyRead, showOnlyEnabled, tagsAdmin, mainBookId}, {order, sort}, token, pageSize) => {
  const url = `${ process.env.REACT_APP_API_URL }books?page=${ page }`;

  return axios.get(url, {
    headers: auth(token),
    params: {
      'book_id': bookId,
      title,
      author,
      isbn,
      'show_no_main_book': showNoMainBook,
      'show_only_want_to_read': showOnlyWantToRead,
      'show_only_already_read': showOnlyAlreadyRead,
      'show_only_enabled': showOnlyEnabled,
      'main_book_id': mainBookId,
      'order': order,
      'admin_tags': tagsAdmin?.find(tag => tag.id === 'no-tags') == null && tagsAdmin?.length > 0 ? tagsAdmin.map(tag => tag.id).join(',') : null,
      'no_tags': tagsAdmin?.find(tag => tag.id === 'no-tags') != null,
      sort,
      'page_size': pageSize,
    }
  });
};

export const saveBookUrl = async (id, url, token) => axios.post(`${ process.env.REACT_APP_API_URL }books/${ id }/sell-url`, { sell_url: url }, { headers: auth(token) });

export const createBook = async (token, {title, authors}) => axios.post(
  `${ process.env.REACT_APP_API_URL }books/create`,
  { title, authors },
  {
    headers: auth(token),
  }
);

export const scrapeAmazon = async (url, token) => axios.get(`${ process.env.REACT_APP_API_URL }main/scrape?url=${encodeURI(url)}`, {headers: auth(token)});
export const listMainBooks = async (page, filters, { order, sort }, token) => {
  return axios.post(`${ process.env.REACT_APP_API_URL }main/book/list`, {page, order, sort, filters},{ headers: auth(token) });
};
export const getMainBook = async (id, token) => axios.get(`${ process.env.REACT_APP_API_URL }main/book/${id}`, {headers: auth(token)});
export const deleteMainBook = async (id, token) => axios.delete(`${ process.env.REACT_APP_API_URL }main/book/${id}`, {headers: auth(token)});
export const saveMainBook = async (data, token) => {
  return axios.post(`${ process.env.REACT_APP_API_URL }main/book`, data, {headers: auth(token)});
}

export const setMainBookShowInApp = async (mainBookId, showInApp, token) => axios.post(
  `${ process.env.REACT_APP_API_URL }main/book/show-in-app`,
  { main_book_id: mainBookId, show_in_app: showInApp },
  { headers: auth(token) }
);

export const setMainBookSortOrder = async (items, token) => axios.post(
  `${ process.env.REACT_APP_API_URL }main/book/sort-order`,
  { items },
  { headers: auth(token) }
);

export const searchSourceBook = async (token, term) => axios.get(`${ process.env.REACT_APP_API_URL }books/autocomplete?term=${term}`, {headers: auth(token)})

export const setQuotesSourceBook = async (token, bookId, quoteIdList) => axios.post(
  `${ process.env.REACT_APP_API_URL }books/quote`,
  {quote_ids: quoteIdList, book_id: bookId},
  {headers: auth(token)}
)

export const getBookQuotes = async (id, token) => axios.get(`${ process.env.REACT_APP_API_URL }books/quotes/${id}`, {headers: auth(token)});

export const searchMainBook = async (token, term) => axios.get(`${ process.env.REACT_APP_API_URL }main/book/autocomplete?term=${term}`, {headers: auth(token)})

export const setMainBook = async (sourceBookId, mainBookId, token) => axios.post(`${ process.env.REACT_APP_API_URL }books/${sourceBookId}/main-book`, { main_book_id: mainBookId }, { headers: auth(token) });

export const setMainBookDefault = async (bookId, token) => axios.post(`${ process.env.REACT_APP_API_URL }books/${bookId}/main-book/default`, {}, { headers: auth(token) });

export const downloadCsv = async (file, token) => axios.get(`${ process.env.REACT_APP_API_URL }reports/download-csv?filename=${file}`, { headers: auth(token), responseType: 'blob' })

export const loadTags = async (token) => axios.get(`${ process.env.REACT_APP_API_URL }tag-admins`, { headers: auth(token) });

export const deleteTagFromBook = async (token, bookId, tagId) => axios.delete(`${ process.env.REACT_APP_API_URL }books/${bookId}/tag/${tagId}`, { headers: auth(token) });

export const addTagToBook = async (token, bookId, tagId) => axios.post(
  `${process.env.REACT_APP_API_URL}books/${bookId}/tags/${tagId}`, {},
  { headers: auth(token) }
);

export const createTag = async (token, tagData) => axios.post(`${ process.env.REACT_APP_API_URL }tag-admins`, tagData, { headers: auth(token) });
export const deleteTag = async (token, tagId) => axios.delete(`${ process.env.REACT_APP_API_URL }tag-admins/${tagId}`, { headers: auth(token) });
export const updateTag = async (token, tagId, tagData) => axios.put(`${ process.env.REACT_APP_API_URL }tag-admins/${tagId}`, tagData, { headers: auth(token) });
